import { defineStore } from 'pinia';
import { useGlobalStore } from '@/store/global-store-base';
import { useApi } from '@lib/api';
import { useUser } from '@/store/user';

export const useSupplierStatuses = defineStore('supplier-statuses', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.brandSupplierStatus_GetList,
    dto: 'BrandSupplierStatusDto',
    create: api.brandSupplierStatus_Create,
    update: api.brandSupplierStatus_Update,
    delete: api.brandSupplierStatus_Delete,
    usage: api.brandSupplierStatus_GetUsage,
    signalR: 'BrandSupplierStatusUpdate',
  });

  async function replace(id: number, replacementId: number) {
    await api.brandSupplierStatus_Replace(useUser().brandId, id, { replacementId });
    await globalStoreBase.loadAll();
  }

  return {
    ...globalStoreBase,
    replace,
  };
});
